var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('router-view')],1),(_vm.$store.state.stateLoad)?_c('div',{attrs:{"id":"efecto_carga"}},[_c('div',{staticClass:"loader3"})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }